import api from '../auth';
const slug = 'api/sis/';

const SiService = () => {
    const getSis = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getSisLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getSi = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteSi = (id) => {
        return api
            .delete(slug + `si/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createSi = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateSi = (id, data) => {
        return api.put(slug + `si/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copySi = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getSis,
        getSisLazy,
        getSi,
        deleteSi,
        createSi,
        updateSi,
        getOptions,
        copySi
    };
};

export default SiService;
